import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import {constants} from '../constants';

const cssMediaItemSettings = {
	desktop: { item: { width: '260px' }},
	laptop: { item: { width: '223px' }},
	tablet: { item: { width: '347px' }},
	mobile: { item: { width: '46%' }}
};

class FourItems extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const posts = this.props.posts.slice(0, 4);
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				{posts.map(p => (<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettings} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />))}
			</div>
		);
	}
}

export default FourItems;



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/FourItems.js